import apiClient from './client';
import { ApiResponse } from '@/types';
import { GatewayOutcome } from './agents.api';

/**
 * Servers page (ai-management-assistant#1): the test server's containers and the Grafana stack.
 */

export interface ContainerInfo {
  name: string;
  image: string;
  state: string;
  status: string;
  created: number;
  project: string | null;
  service: string | null;
  ports: string[];
}

export interface ContainerGroup {
  project: string;
  running: number;
  containers: ContainerInfo[];
}

export type StackState = 'up' | 'partial' | 'down' | 'unknown';

export interface StackRequest {
  at: string;
  by?: string;
  action: 'up' | 'down';
  hours?: number;
  decision: string;
  pipelineId?: number;
  url?: string;
  status?: string;
  problem?: string;
}

export interface ServersOverview {
  containers: ContainerGroup[] | null; // null: the container list did not answer
  grafana: {
    state: StackState;
    running: string[];
    missing: string[];
    url: string;
    stopsAt?: string;
    lastRequest?: StackRequest;
    history: StackRequest[];
  };
}

export async function getServers(): Promise<ServersOverview> {
  const response = await apiClient.get<ApiResponse<ServersOverview>>('/servers');
  return response.data.data as ServersOverview;
}

/** Up (for hours, or until stopped) or Down: starts the infra pipeline through the gateway */
export async function grafanaStack(action: 'up' | 'down', hours?: number): Promise<GatewayOutcome> {
  const response = await apiClient.post<ApiResponse<GatewayOutcome>>('/servers/grafana', { action, ...(hours ? { hours } : {}) });
  return response.data.data as GatewayOutcome;
}
